export default {
  quantities: ['10', '25', '50', '100'],
  part_number: '',
  revision: '',
  number_of_layers: '2',
  board_length: '',
  board_width: '',

  has_array: '0',
  is_panelized: '',
  array_x: '',
  array_y: '',
  array_up: '',
  array_x_qty: '',
  array_y_qty: '',
  array_spacing_x: '',
  array_spacing_y: '',
  rails_left: '',
  rails_right: '',
  rails_top: '',
  rails_bottom: '',
  tab_rout: '0',
  scoring: '0',

  material_type: 'FR4',
  material_thickness: '0.062',
  finish_plating: 'Leaded Hasl',
  copper_inners: '1 oz',
  copper_outers: '1 oz',
  //

  // min_trace_space  : 0.012,
  solder_sides: 'Both Sides',
  solder_color: 'green',
  silkscreen_sides: 'Both Side',
  silkscreen_color: 'White',

  has_advanced_specs: '0',
  gold_fingers: '0',
  gold_thickness: 'Au < 10u"',
  pitch: '0.0',
  min_trace_space: '0.008',
  blind_buried_hole: 'None',
  smallest_hole_size: '0.01',


  plated_slots: '0',
  counterbores: '0',
  blind_slot: '0',
  plated_edges: '0',
  countersinks: '0',
  controlled_dielectric: '0',
  controlled_impedance: '0',

  special_instructions: '',

  ul: '1',
  lot_code: '1',
  panel_approval: '0',

  quote_weight: '0',
  weight_unit: 'kg',
  no_expedited: '1',
};
